import React, {useState, useContext} from 'react'
import SelLangComp from '../SelLangComp/SelLangComp'
import {GlobalLangCtx} from '../../App'
import "./NavBar.css"
import { useEffect } from 'react'

const Navbar = () =>{

    function handlePosition(nodeEl){
        const el = document.getElementById(nodeEl)
        const pos = Math.round(el.getClientRects()[0].y);        
        document.querySelector(".s_main").scrollTo({ top: pos, behavior: "smooth" })
    } 

    useEffect(() =>{
        document.querySelector(".mItems").focus()
        document.querySelector(".mItems").blur()
    },[])
    
    const [selLan, setselLan] = useContext(GlobalLangCtx);
    const fLan = require (`../language_app/json_files/lang[${selLan}].json`)
    

    return(
        <nav>
            <div id='navBar' className={"mainBlock"}>

                <div className="leftBlk">
                    <ul className="menuItems">
                        <li tabIndex={1} className="mItems" onClick={() => { handlePosition("aboutBox")   } } >Info</li>
                        <li className="mItems" onClick={() => { handlePosition("skillsComp") } } >Skills</li>
                        <li className="mItems" onClick={() => { handlePosition("projectComp") } } >  { fLan.navBar.el1 }</li>
                        <li className="mItems" onClick={() => { handlePosition("contactsComp") } } > { fLan.navBar.el2 }</li>
                    </ul>
                </div>

                <SelLangComp/>

            </div>
        </nav>
    )
}


export default Navbar;